export const isValidLEI = (lei: string) => {
  // LEI must be exactly 20 characters long
  if (lei.length !== 20) {
    return false;
  }

  // Regular expression: first 18 characters alphanumeric (A-Z, 0-9) and last 2 must be digits.
  const regex = /^[A-Z0-9]{18}[0-9]{2}$/;
  if (!regex.test(lei)) {
    return false;
  }

  // Convert the first 18 characters: digits remain the same; letters are converted (A=10, ..., Z=35)
  let numericStr = '';
  for (let i = 0; i < 18; i++) {
    const char = lei[i];
    if (/[0-9]/.test(char)) {
      numericStr += char;
    } else if (/[A-Z]/.test(char)) {
      // Convert letter to number: 'A'.charCodeAt(0) = 65 so A -> 10, B -> 11, ... Z -> 35.
      numericStr += (char.charCodeAt(0) - 55).toString();
    } else {
      // Shouldn't happen because of regex check, but just in case.
      return false;
    }
  }

  // Append "00" for the check digit calculation
  numericStr += '00';

  // Use BigInt for large number arithmetic to compute modulus 97
  const remainder = BigInt(numericStr) % BigInt(97);
  const calculatedCheck = 98 - Number(remainder);

  // Format check digits as two digits (prepend '0' if needed)
  const checkDigits =
    calculatedCheck < 10 ? `0${calculatedCheck}` : calculatedCheck.toString();

  // Compare computed check digits with the last two digits of the LEI
  return lei.slice(18) === checkDigits;
};
